import { render, staticRenderFns } from "./ListaCoberturas.vue?vue&type=template&id=11bf2924"
import script from "./ListaCoberturas.vue?vue&type=script&setup=true&lang=js"
export * from "./ListaCoberturas.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports